import React, { useEffect, useState } from 'react'
import Container from '../../base/Container'
import Card from '../../controls/Card'
import * as opdRegisteredCrud from '../../../configurations/crud/opdRegisteredCrud'
import { useToast } from '../../controls/Toast/ToastService'
import { getLoginInfo } from '../../../configurations/auth/getLoginInfo'
import LookOutRegistered from './LookOutRegistered'
import LookOutEmergency from './LookOutEmergency'
import LookOutConfirmed from './LookOutConfirmed'
import useGlobalLoader from '../../../configurations/useGlobalLoader'
import { MdErrorOutline } from 'react-icons/md'
import { GetAllByUser } from "../../../configurations/crud/opdCentersCrud"
import Datepicker from 'react-tailwindcss-datepicker'
import { FaClinicMedical } from 'react-icons/fa'
import Select from '../../controls/Select'
import moment from 'moment'
import ForDateShortReport from '../report/ForDateShortReport'

export default function LookOut({ }) {
    const { start, end } = useGlobalLoader()
    const toast = useToast()
    const [loding, setLoding] = useState(false)
    const [serachPatient, setSerachPatient] = useState("")
    const [isSerachPatient, setIsSerachPatient] = useState(0)
    const [opdCenters, setOpdCenter] = useState([]);
    const [selectedCenter, setSelectedCenter] = useState("");
    const [viewUsers, setViewUsers] = useState(1);
    const [value, setValue] = useState({
        startDate: new Date(),
        endDate: new Date()
    });

    useEffect(() => {
        getAllOpdCenters()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    function getAllOpdCenters() {
        setLoding(true);
        start()
        GetAllByUser()
            .then((res) => {
                let mdata = res.data;
                if (mdata.result.succeeded) {
                    setOpdCenter(mdata.data);
                } else {
                    setOpdCenter([]);
                    toast.open(mdata.result.message, <MdErrorOutline />, "danger");
                }
                setLoding(false);
                end()
            })
            .catch((errors) => {
                setOpdCenter([]);
                setLoding(false);
                end()
                toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
            });
    }

    const TABS = [
        { id: 1, label: "Registered", color: "bg-blue-500" },
        { id: 2, label: "Confirmed", color: "bg-green-500" },
        { id: 3, label: "Emergency", color: "bg-red-500" },
    ]
    const searchScope = viewUsers == 1 ? "registered" : viewUsers == 2 ? "confirmed" : "emergency"
    const forDate = moment(new Date(value.startDate)).format("MM/DD/YYYY")

    return (
        <Container>
            <div className="flex w-full flex-col px-2 sm:px-4">

                {/*
                  Filter is a plain card-styled container (NOT the <Card> component)
                  so overflow stays visible and the datepicker popover isn't clipped.
                */}
                <div className="relative z-30 overflow-visible rounded-2xl border border-brand-400 bg-white p-4 shadow-sm">
                    <h2 className="mb-3 text-base font-semibold text-gray-800">Look Out OPD</h2>
                    <div className="flex flex-col gap-3 sm:flex-row sm:gap-4">
                        <div className="w-full">
                            <label className="mb-1 block text-sm font-medium text-gray-700">Select Center</label>
                            <Select
                                Icon={<FaClinicMedical className="text-lg text-red-600" />}
                                value={selectedCenter}
                                onChange={(e) => setSelectedCenter(e.target.value)}
                            >
                                <option value="">Select Center...</option>
                                {opdCenters.map(item => (
                                    <option key={item.id} value={item.id}>{item.centerName}</option>
                                ))}
                            </Select>
                        </div>
                        <div className="relative z-50 w-full">
                            <label className="mb-1 block text-sm font-medium text-gray-700">Select Date</label>
                            <Datepicker
                                popoverDirection="down"
                                useRange={false}
                                asSingle={true}
                                displayFormat="DD/MM/YYYY"
                                readOnly={true}
                                primaryColor={"sky"}
                                value={value}
                                onChange={newValue => setValue(newValue)}
                                containerClassName="relative z-[100]"
                                inputClassName="outline-none bg-white border border-gray-200 text-gray-900 text-sm rounded-xl shadow-soft focus:ring-2 focus:ring-brand-400/30 focus:border-brand-400 w-full p-2.5"
                            />
                        </div>
                    </div>
                </div>

                {selectedCenter && value.startDate &&
                    <>
                        <div className="my-2" />
                        <ForDateShortReport centerId={selectedCenter} forDate={forDate} />

                        <Card isBorder={true}>
                            <div className="flex flex-col gap-2">
                                {/* tabs */}
                                <div className="flex flex-1 gap-1 overflow-x-auto rounded-xl bg-gray-100 p-1">
                                    {TABS.map((t) => (
                                        <button
                                            key={t.id}
                                            type="button"
                                            onClick={() => setViewUsers(t.id)}
                                            className={`shrink-0 rounded-lg px-3 py-2 text-xs font-semibold transition sm:px-4 sm:text-sm ${viewUsers == t.id ? `${t.color} text-white shadow` : "text-gray-500 hover:text-gray-700"}`}
                                        >
                                            {t.label}
                                        </button>
                                    ))}
                                </div>

                                {/* search (now available on all sizes) */}
                                <div className="flex items-center gap-2">
                                    <input
                                        type="text"
                                        value={serachPatient}
                                        onChange={(e) => setSerachPatient(e.target.value)}
                                        placeholder={`Search ${searchScope} patient...`}
                                        className="block w-full rounded-lg border border-gray-300 bg-gray-50 p-2.5 text-sm text-gray-900 outline-none focus:border-blue-500 focus:ring-blue-500"
                                    />
                                    <button
                                        onClick={() => setIsSerachPatient(pre => pre + 1)}
                                        className="grid h-10 w-10 shrink-0 place-items-center rounded-lg border border-brand-600 bg-brand-500 text-white transition hover:bg-brand-600 focus:outline-none focus:ring-4 focus:ring-brand-600/40"
                                    >
                                        <svg className="h-4 w-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                                            <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z" />
                                        </svg>
                                        <span className="sr-only">Search</span>
                                    </button>
                                </div>
                            </div>

                            {/* tab content */}
                            <div className="mt-3">
                                {viewUsers == 1 &&
                                    <LookOutRegistered isActive={viewUsers == 1} searchTerm={serachPatient} isSearch={isSerachPatient} centerId={selectedCenter} forDate={forDate} />
                                }
                                {viewUsers == 2 &&
                                    <LookOutConfirmed isActive={viewUsers == 2} searchTerm={serachPatient} isSearch={isSerachPatient} centerId={selectedCenter} forDate={forDate} />
                                }
                                {viewUsers == 3 &&
                                    <LookOutEmergency isActive={viewUsers == 3} searchTerm={serachPatient} isSearch={isSerachPatient} centerId={selectedCenter} forDate={forDate} />
                                }
                            </div>
                        </Card>
                    </>
                }
            </div>
        </Container>
    )
}